import { createTheme, ThemeProvider } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";

import { ButtonContainer } from "./styles";
import theme from "../../utils/theme";
import { CircularProgress } from "@mui/material";

const { colors } = theme;

const muiTheme = createTheme({
	palette: {
		primary: {
			main: colors.primary,
		},
		secondary: {
			main: colors.secondary,
		},
	},
});

interface ButtonProps {
	disabled?: boolean;
	label?: string;
	datatestid?: string;
	onClick?: (e?: any) => void;
	className?: string;
	variant?: "text" | "outlined" | "contained";
	size?: "small" | "medium" | "large";
	secondary?: boolean;
	buttonClass?: string;
	loading?: boolean;
	visible?: boolean;
}

const Button = ({
	disabled = false,
	datatestid,
	secondary = false,
	label = "",
	onClick = () => null,
	className = "",
	buttonClass = "",
	variant,
	size = "medium",
	loading = false,
	visible = true,
}: ButtonProps) => {
	if (!visible) return null;

	return (
		<ButtonContainer className={className}>
			<ThemeProvider theme={muiTheme}>
				<MuiButton
					disabled={disabled}
					data-testid={datatestid}
					variant={variant}
					size={size}
					color={secondary ? "secondary" : "primary"}
					className={
						(secondary
							? "border boder-1 "
							: variant == "outlined"
							? ""
							: (disabled ? "bg-primary-subtle" : "bg-primary") + " text-white ") + buttonClass
					}
					onClick={disabled || loading ? () => {} : onClick}
				>
					{loading && <CircularProgress style={{ color: "white" }} className="position-absolute" size={15} />}
					<div color={loading ? "primary" : "inherit"} className={loading ? "invisible" : "primary"}>
						{label}
					</div>
				</MuiButton>
			</ThemeProvider>
		</ButtonContainer>
	);
};

export default Button;
